<form [id]="formId()" [formGroup]="sendFormService.sendForm()" [bitSubmit]="submit">
  @if (!loading) {
    <tools-send-details></tools-send-details>
  }
</form>
